import { mdlRoute } from "../models/ui-models/Route";
import { routeContants } from "./RouteConstants";

export const routeDefinitions: Array<mdlRoute> = [
  {
    path: routeContants.DASHBOARD,
    label: "route.dashboard",
  },
  {
    path: routeContants.RESERVATION_MONITOR,
    label: "route.reservationMonitor",
  },
  {
    path: routeContants.ENRTRY_LIST,
    label: "route.entryList",
  },
  {
    path: routeContants.OFFERS,
    label: "route.offers",
  },
  {
    label: "route.stopFreeSale",
    items: [
      {
        path: routeContants.STOP_FREE_SALE_ADD,
        label: "route.addNewStopFeeSale",
      },
      {
        path: routeContants.STOP_FREE_SALE_SENDED,
        label: "route.sendedStopFeeSale",
      },
      {
        path: routeContants.STOP_FREE_SALE_REPORT,
        label: "route.reportStopFeeSale",
      },
      {
        path: routeContants.STOP_FREE_SALE_MESSAGE,
        label: "route.messageStopFeeSale",
      },
    ]
  },
  {
    path: routeContants.ACTIONS,
    label: "route.actions",
    items: [
      {
        path: routeContants.ACTION_CREATE,
        label: "route.actionCreate",
      },
      {
        path: routeContants.ACTION_HISTORY,
        label: "route.actionHistory",
      },
      {
        path: routeContants.ACTION_REPORTS,
        label: "route.actionReports",
      }
    ]
  },
  {
    label: "route.definitions",
    items: [
      {
        path: routeContants.MARKET_DEFINITIONS,
        label: "route.marketDefinitions",
      },
      {
        path: routeContants.OTHER_AGENCY_DEFINITIONS,
        label: "route.otherAgencyDefinitions",
      },
      {
        path: routeContants.AGENCY_MARKETS_DEFINITIONS,
        label: "route.agencyMarketDefinitions",
      },
      {
        path: routeContants.ROOM_DEFINITIONS,
        label: "route.roomDefinitions",
      },
      {
        path: routeContants.NOTCONFRIM_DEFINITIONS,
        label: "route.notConfirmDefinitions",
      },
      // {
      //   path: routeContants.TEMPLATE_DEFINITIONS,
      //   label: "route.templateDefinitions",
      // },
      {
        path: routeContants.BOARD_DEFINITIONS,
        label: "route.boardDefinitions",
      },
      {
        path: routeContants.USER_DEFINITIONS,
        label: "route.userDefinitions",
      }
    ],
  },
  {

    label: "route.help",
    items: [
      {
        label: "route.userManual",
        items: [
          {
            label: "route.userManual",
            path: routeContants.HELP_USERMANUAL_USER_MANUAL,

          },
          {
            label: "route.news",
            path: routeContants.HELP_USERMANUAL_NEWS,

          }
        ]
      },
      {
        label: "route.faq",
        path: routeContants.HELP_FAQ,

      },
      {
        label: "route.contactUs",
        path: routeContants.HELP_CONTACT_US,
      }
    ]
  },
  {
    path: routeContants.PARAMETERS,
    label: "route.parameters"
  },
  {
    path: routeContants.AGENCIES,
    label: "route.agencies",
  },
  {
    path: routeContants.OTHERS,
    label: "route.others",
    items: [

      {
        path: routeContants.PMS_INTEGRATIONS,
        label: "route.pmsIntegrations",
      },
      {
        path: routeContants.FACT_SHEET_DASHBOARD,
        label: "route.faceSheetDashbord",
      },
      {
        path: routeContants.TOURISM_NEWS,
        label: "route.tourismNews",
      },
    ]
  },
  {
    path: routeContants.PAYMENT,
    label: "route.payment"
  }
];